import {
  Box,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
} from '@material-ui/core';

import React from 'react';

import { Clear } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    advancedSearch: {
      zIndex: 0,
      fontSize: 12,
      fontWeight: 'normal',
      alignSelf: 'self-end',
      transform: 'translate(-7px, -23px)',
      color: 'white',
      '> a': {},
    },
    advancedSearchLink: {
      color: 'white',
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.primary.light,
      },
    },
    localSearchInput: {
      zIndex: 1,
      padding: 6,
      border: 0,
    },
  })
);

export const LocalSearchInput = ({
  filter,
  setFilter,
}: {
  filter: string;
  setFilter: (value: string) => void;
}) => {
  const classes = useStyles();

  return (
    <Box style={{ height: 30 }}>
      <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="row" style={{ background: 'white' }}>
          <input
            placeholder="Vyhledat"
            className={classes.localSearchInput}
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
          {filter && (
            <IconButton
              onClick={() => setFilter('')}
              style={{ padding: 0, zIndex: 2 }}
            >
              <Clear style={{ color: 'grey' }} />
            </IconButton>
          )}
        </Box>
        <span className={classes.advancedSearch}>
          <Link
            className={classes.advancedSearchLink}
            color="white"
            to="/hledat"
            target="_blank"
          >
            Pokročilé vyhledávání
          </Link>
        </span>
      </Box>
    </Box>
  );
};
